<div class="site-note-template">
	<form class="main-form" [formGroup]="siteNoteForm">
		<div class="container column resource-selector" *ngIf="locationTypes.length > 0">
			<div class="label">Location:</div>
			<mat-form-field [floatLabel]="'never'" class="container test">				
				<mat-select formControlName="locationTypeId" placeholder="Please select a Location Type">
					<mat-option *ngFor="let item of locationTypes" [value]="item.resourceTypeId">
						{{item.resourceTypeName}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field [floatLabel]="'never'" *ngIf="locationTypeId.value" class="container test">
				<mat-select [disabled]="!locationTypeId.value" formControlName="locationId" placeholder="Please select a Location">
					<mat-option *ngFor="let item of possibleLocations" [value]="item.assetId">
						{{item.assetName}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="container column resource-selector" *ngIf="assetTypes.length > 0">
			<div class="label">Asset:</div>
			<mat-form-field [floatLabel]="'never'" class="container test">
				<mat-select formControlName="assetTypeId" placeholder="Please select an Asset Type">
					<mat-option *ngFor="let item of assetTypes" [value]="item.resourceTypeId">
						{{item.resourceTypeName}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field [floatLabel]="'never'" *ngIf="assetTypeId.value" class="container test">
				<mat-select [disabled]="!assetTypeId.value" formControlName="assetId" placeholder="Please select an Asset Type">
					<mat-option *ngFor="let item of possibleAssets" [value]="item.assetId">
						{{item.assetName}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="container">
			<mat-checkbox formControlName="isEmergency">Emergency</mat-checkbox>
			<mat-checkbox formControlName="notifyOthers">Notify Other (by SMS and email)</mat-checkbox>
		</div>
	
		<ng-container *ngIf="!isOnCompleteNote">
			<mat-form-field class="container column">
				<mat-label>Comment</mat-label>
				<textarea rows="7" matInput formControlName="message"></textarea>
			</mat-form-field>
		</ng-container>
		<ng-container *ngIf="isOnCompleteNote">
			<div class="container comment">
				<span>Comment:</span>
				<div>
					<span>{{siteNoteForm.get('message')?.value}}</span>
				</div>
			</div>
		</ng-container>

	
		<div class="container assignee-selector-container">
			<mat-checkbox formControlName="isCompletionRequired">Requires Completion</mat-checkbox>

			<mat-form-field class="container assignee-selector" *ngIf="isOnCompleteNote">
				<mat-label>Assigned To</mat-label>
				<input matInput formControlName="assignedUserId">
			</mat-form-field>

			<mat-form-field class="container assignee-selector" *ngIf="siteNoteForm.get('isCompletionRequired').value && !isOnCompleteNote">
				<mat-label>Assigned To</mat-label>
				<mat-select formControlName="assignedUserId">
					<mat-option *ngFor="let item of possibleAssignees" [value]="item.userAccountId">
						{{item.fullName}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</form>
</div>
